import { Grid } from '@mui/material';
import { memo } from 'react';
import PmiTextField from 'shell/components/shared/text-field';
import { Residence } from 'front-office/view-models/release-id-card/residence';

interface FormProps {
  onChange: (key: keyof Residence, value: Residence[keyof Residence]) => void;
  values?: Residence;
  disabled?: boolean;
}

const CivicNumberComponent = ({ onChange, values, disabled }: FormProps): React.ReactElement => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={3}>
        <PmiTextField
          aria-label="Numero"
          label="Numero"
          id="number"
          name="number"
          fullWidth
          disabled={disabled}
          type="text"
          variant="outlined"
          value={values?.number || ''}
          onChange={(event) => {
            onChange('number', event.target.value);
          }}
          inputProps={{ maxLength: '20' }}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <PmiTextField
          aria-label="Lettera"
          label="Lettera"
          id="letter"
          name="letter"
          fullWidth
          disabled={disabled}
          type="text"
          variant="outlined"
          value={values?.letter || ''}
          onChange={(event) => {
            onChange('letter', event.target.value);
          }}
          inputProps={{ maxLength: '10' }}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <PmiTextField
          aria-label="Esponente"
          label="Esponente"
          id="exponent"
          name="exponent"
          fullWidth
          disabled={disabled}
          type="text"
          variant="outlined"
          value={values?.exponent || ''}
          onChange={(event) => {
            onChange('exponent', event.target.value);
          }}
          inputProps={{ maxLength: '20' }}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <PmiTextField
          aria-label="Colore"
          label="Colore"
          id="color"
          name="color"
          fullWidth
          disabled={disabled}
          type="text"
          variant="outlined"
          value={values?.color || ''}
          onChange={(event) => {
            onChange('color', event.target.value);
          }}
          inputProps={{ maxLength: '1' }}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <PmiTextField
          aria-label="Codice civico"
          label="Codice civico"
          id="civicCode"
          name="civicCode"
          fullWidth
          disabled={disabled}
          type="text"
          variant="outlined"
          value={values?.civicCode || ''}
          onChange={(event) => {
            onChange('civicCode', event.target.value);
          }}
          inputProps={{ maxLength: '10' }}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <PmiTextField
          aria-label="Civico fonte"
          label="Civico fonte"
          id="sourceCivic"
          name="sourceCivic"
          fullWidth
          disabled={disabled}
          type="text"
          variant="outlined"
          value={values?.sourceCivic || ''}
          onChange={(event) => {
            onChange('sourceCivic', event.target.value);
          }}
          inputProps={{ maxLength: '1' }}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <PmiTextField
          aria-label="Metrica"
          label="Metrica"
          id="metric"
          name="metric"
          fullWidth
          disabled={disabled}
          type="text"
          variant="outlined"
          value={values?.metric || ''}
          onChange={(event) => {
            onChange('metric', event.target.value);
          }}
          inputProps={{ maxLength: '6' }}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <PmiTextField
          aria-label="Prog.SNC"
          label="Prog.SNC"
          id="prog"
          name="prog"
          fullWidth
          disabled={disabled}
          type="text"
          variant="outlined"
          value={values?.prog || ''}
          onChange={(event) => {
            onChange('prog', event.target.value);
          }}
          inputProps={{ maxLength: '5' }}
        />
      </Grid>
    </Grid>
  );
};

CivicNumberComponent.displayName = 'Civic Number residence';

const CivicNumber = memo(CivicNumberComponent);

export default CivicNumber;
